import { Injectable } from '@angular/core';

@Injectable()
export class CourseManagementService {
  public selectedCategory;
  public selectedCourse;
  public organisationId;

  constructor() { }

  setSelectedCategory(category) {
    this.selectedCategory = category;
    // console.log(this.selectedCategory);
  }

  getSelecteCategory() {
    return this.selectedCategory;
  }

  setSelectedTopic(course) {
    this.selectedCourse = course;
  }

  getSelectedTopic() {

    return this.selectedCourse;
  }

  setOrganisationId(orgId){
    this.organisationId=orgId;
  }

  getOrganisationId(){

    return this.organisationId;
  }
}



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/feature-modules/admin/admin-services/course-management.service.ts